import script from "./LocalizableComponent.vue?vue&type=script&lang=js"
export * from "./LocalizableComponent.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__